import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type AppointmentExtraDTO = {
    id: number;
    serviceTip: number;
  };
  
export type LineItem = {
    subTotal: number;
    total: number;
    advPayment: number;
    storeDisc: number;
    othCharges: number;
    serviceTip: number;
  };
  
  export const handleAppointmentExtras = ({
    id,
    serviceTip,
  }: AppointmentExtraDTO): Promise<LineItem> => {
    return axios.post(
       `/parent/payment/update-extra/${id}`,
      {  serviceTip }
    );
  };
  
  type UseUpdateAppoinmentOptions = {
    config?: MutationConfig<typeof handleAppointmentExtras>;
  };
  
  export const useUpdateAppoinment = ({ config }: UseUpdateAppoinmentOptions = {}) => {
    return useMutation({
      onSuccess: () => {
        showNotification({
          type: 'success',
          title: 'Appointment updated successfully',
        });
      },
      ...config,
      mutationFn: handleAppointmentExtras,
    });
  };